
import { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import './CSS/stateDisplay.css'

function StateDisplay({ statePack }) {

    const { isConnected, approvedAmount, maxMintQuantity, apprAmt,
        handleApprove, handleMint, mintQuantity, setMintQuantity, BBCBalance,
        corrChainId, chain, switchNetwork, costBTRFLY, BTRFLYbalance } = statePack


    const [displayMintQuantity, setDisplayMintQuantity] = useState(1)

    function changeQuantity(amount) {
        const check = (mintQuantity + amount)
        if (check < 1 || check > maxMintQuantity) return
        setMintQuantity((mintQuantity) => {
            return mintQuantity + amount
        })
    }

    function transact({ handler }) {
        toast.promise(
            () => handler?.(),
            {
                pending: 'Transaction Confirming...',
                success: 'Transaction Sent!',
                error: 'Transaction Cancelled!'
            }
        )
    }

    const insuffBTRFLY = ((costBTRFLY * displayMintQuantity) > BTRFLYbalance?.value)

    const mintAllowance = (maxMintQuantity - BBCBalance)

    useEffect(() => {
        if (insuffBTRFLY) return
        setMintQuantity(displayMintQuantity)    // Avoids invalid args for prepare mint hook, prevents errors thrown
    }, [displayMintQuantity]);

    if (isConnected) {
        if (corrChainId === chain.id) {
            if (approvedAmount >= apprAmt) {
                return (
                    <>
                        {insuffBTRFLY ?
                            <button className="mainButtonDisabled">No monies</button>
                            :
                            <button className="mainButton" onClick={() => transact({ handler: handleMint })}>Mint {mintQuantity}</button>
                        }
                        <p>You may mint {mintAllowance} Baby Butterflies</p>
                        <p>Cost: {displayMintQuantity} BTRFLY<br />Balance: {Math.round(BTRFLYbalance?.formatted * 100) / 100} BTRFLY</p>
                        <input type='range' min='1' max={mintAllowance} value={displayMintQuantity} onChange={(e) => {
                            setDisplayMintQuantity(e.target.value)
                        }}>
                        </input>
                    </>
                )
            }

            else {
                return (
                    <>
                        <button className="mainButton" onClick={() => { transact({ handler: handleApprove }) }}>Approve</button>
                        <p>This account is not approved to spend BTRFLY<br />Please approve this account</p>
                    </>
                )
            }
        }

        else {
            return (
                <>
                    <button className="mainButton" onClick={() => switchNetwork?.(corrChainId)}>Connect:<br />Goerli</button>
                    <p>Please switch to the Goerli network!</p>
                </>
            )
        }
    }

    else {
        return (
            <>
                <h1>Welcome!</h1>
                <p>Please connect your wallet to continue</p>
            </>
        )
    }

}

export default StateDisplay